/**
 * Token Debugging Utility
 *
 * Run this in browser console to diagnose token issues:
 * window.debugToken()
 */

import { isValidJWT, getUploaderToken } from 'Api';

/**
 * Debug current token in localStorage
 */
export function debugToken() {
  console.log('=== TOKEN DEBUGGER ===\n');

  // Check user token
  const userToken = localStorage.getItem('token');
  console.log('1. User Token (from localStorage):');
  console.log('   Value:', userToken ? `${userToken.substring(0, 50)}...` : 'NOT FOUND');
  console.log('   Length:', userToken?.length || 0);
  console.log('   Is JWT?:', isValidJWT(userToken));

  if (userToken) {
    const parts = userToken.split('.');
    console.log('   Parts count:', parts.length, '(JWT should have 3)');

    if (parts.length === 3) {
      try {
        const header = JSON.parse(atob(parts[0]));
        const payload = JSON.parse(atob(parts[1]));

        console.log('   Header:', header);
        console.log('   Payload:', {
          ...payload,
          exp: payload.exp ? new Date(payload.exp * 1000).toISOString() : 'N/A',
          iat: payload.iat ? new Date(payload.iat * 1000).toISOString() : 'N/A',
        });

        if (payload.exp) {
          const now = Date.now();
          const expiry = payload.exp * 1000;
          const isExpired = now > expiry;
          const timeLeft = expiry - now;

          console.log('   Expired?:', isExpired);
          if (!isExpired) {
            console.log('   Time left:', Math.floor(timeLeft / 1000 / 60), 'minutes');
          }
        }
      } catch (error) {
        console.error('   Failed to decode JWT:', error.message);
      }
    } else {
      console.warn('   ⚠️ NOT a valid JWT! Expected format: header.payload.signature');
      console.warn('   This token will NOT work with the upload service!');
    }
  }

  // Check cached uploader token
  const uploaderToken = localStorage.getItem('uploader_token');
  const uploaderExpiry = localStorage.getItem('uploader_token_expiry');
  const userUuid = localStorage.getItem('user_uuid');

  console.log('\n2. Cached Uploader Token:');
  console.log('   Value:', uploaderToken ? `${uploaderToken.substring(0, 50)}...` : 'NOT CACHED');
  console.log('   Is JWT?:', uploaderToken ? isValidJWT(uploaderToken) : 'N/A');
  console.log('   Expiry:', uploaderExpiry ? new Date(parseInt(uploaderExpiry, 10)).toISOString() : 'N/A');

  if (uploaderExpiry) {
    const now = Date.now();
    const expiry = parseInt(uploaderExpiry, 10);
    const isExpired = now > expiry;
    console.log('   Expired?:', isExpired);
    if (!isExpired) {
      console.log('   Time left:', Math.floor((expiry - now) / 1000 / 60), 'minutes');
    }
  }

  console.log('\n3. User UUID (for S3 paths):');
  console.log('   Value:', userUuid || 'NOT FOUND');
  if (!userUuid) {
    console.warn('   ⚠️ User UUID missing - required for S3 key generation!');
  }

  // Test fetching uploader token
  console.log('\n4. Testing getUploaderToken()...');
  getUploaderToken()
    .then((token) => {
      console.log('   ✅ Success! Got uploader token:', `${token.substring(0, 50)}...`);
      console.log('   Is JWT?:', isValidJWT(token));
      console.log('   Token will be used for upload service API calls');
      console.log('\n=== TOKEN DEBUG COMPLETE ===');
      console.log('\n💡 TIP: If upload token is valid, you can now test uploading a file!');
    })
    .catch((error) => {
      console.error('   ❌ Failed to get uploader token:', error.message);
      console.error('   Check that you are logged in and profile API returns api_response.access');
      console.log('\n=== TOKEN DEBUG COMPLETE (WITH ERRORS) ===');
    });
}

// Make it globally available for browser console
if (typeof window !== 'undefined') {
  window.debugToken = debugToken;
  console.log('💡 Token debugger loaded! Run window.debugToken() to check your tokens.');
}

export default debugToken;
